export const SERVICE_WORKER_REGISTRATION_LOG_EVENT_CHANNEL_NAME: string = "sw-reg-log-events";
export const SERVICE_WORKER_REGISTRATION_NEWVERSION_EVENT_CHANNEL_NAME: string = "sw-reg-newversion-events";